export const getFormattedCategories = (categories) => {
  return categories.reduce((formattedCategories, category) => {
    formattedCategories?.push({ id: category.id, label: category.name });
    return formattedCategories;
  }, []);
};
